import {
  put, select, takeLatest, all, call
} from 'redux-saga/effects';
import { push, LOCATION_CHANGE } from 'connected-react-router';
import { actions, actionCreators } from 'react/api/actions/tabs';
import { EXTERNAL_LINK_MENUITEMS } from 'react/api/constants/tabs';

export function* onCloseTabSaga({ payload }) {
  const { tabs } = yield select();
  const objectKey = payload.get('key') === 'TrackEquipmentMapsDisplay'
    ? 'TrackEquipmentMaps'
    : payload.get('key');
  const router = App.Objects[objectKey];
  if (router && router.onClose) {
    router.onClose();
  }

  if (tabs.get('active').get('key') === payload.get('key')) {
    const tab = tabs.get('list').last();
    if (tab) {
      yield put(actionCreators.onSelect(tab));
    } else {
      yield put(push('/'));
    }
  }
}

function* onSelectTabSaga({ payload }) {
  if (!payload.get('pathname').match(/help_/)) {
    yield put(push(payload.get('pathname')));
  }
}

function* onExpandTabSaga({ payload }) {
  let page = `#${payload.get('pathname')}`;
  if (page.match(/help/g)) {
    page = document.querySelector(`div${page} iframe`).getAttribute('src');
  }
  yield call(
    window.open,
    page,
    'mywin',
    'left=0,top=0,toolbar=yes,location=yes,directories=yes,status=no,menubar=yes,scrollbars=yes,copyhistory=no,resizable=yes'
  );
}

function* onChangeLocationSaga({ payload: { action, location } }) {
  if (action === 'POP' || action === 'REPLACE' || action === 'PUSH') {
    const { pathname } = location;
    const key = pathname.split('/').slice(1);

    if (key in EXTERNAL_LINK_MENUITEMS) {
      yield call(
        window.open,
        EXTERNAL_LINK_MENUITEMS[key],
        '_blank',
        'noopener,noreferrer'
      );
    }
  }
}
function* watchChangeLocation() {
  yield takeLatest(LOCATION_CHANGE, onChangeLocationSaga);
}

function* watchOnSelectTabs() {
  yield takeLatest(actions.onSelect, onSelectTabSaga);
}

function* watchOnCloseTab() {
  yield takeLatest(actions.onClose, onCloseTabSaga);
}

function* watchExpandTabAction() {
  yield takeLatest(actions.onExpand, onExpandTabSaga);
}

export default function* () {
  yield all([
    watchOnCloseTab(),
    watchOnSelectTabs(),
    watchExpandTabAction(),
    watchChangeLocation()
  ]);
}
